<div class="d-flex flex-row">
    <span *ngIf="label" class="fw-bold m-2">{{label}}:</span>
    <chip-filter [items]="chips" [(selectedIndex)]="selectedIndex" (selectedItem)="onClick($event)"></chip-filter>
</div>